<app-orders-panel [title]="'Historia zamówień'"></app-orders-panel>
